import * as moment from 'moment';

export function hydrateReservation(reservation) {
    const momentDebut = moment.unix(reservation.debut);
    const momentFin = moment.unix(reservation.fin);

    let people = reservation.clients ? reservation.clients.reduce((previous, current) => {
        const name = (current.clientId ? current.clientNom : current.externe);

        const separator = previous ? ', ' : '';

        return previous + (name ? separator + name : '');
    }, '') : '';

    if( !people && reservation.id ) {
        people = 'vous même';
    }

    return {
        ...reservation,
        momentDebut,
        momentFin,
        people
    };
}